import React, { useState, useEffect } from "react";
import styled, { keyframes, css } from "styled-components";
import email from "../../assets/email.png";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-20px);
  }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  opacity: ${(props) => (props.isClosing ? "0" : "1")};
  transition: opacity 0.3s ease-out;
`;

const ModalContainer = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 12px;
  width: 90%;
  max-width: 500px;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  ${(props) =>
    props.isClosing
      ? css`
          animation: ${fadeOut} 0.3s ease-out;
        `
      : css`
          animation: ${fadeIn} 0.3s ease-out;
        `}
`;

const IconWrapper = styled.div`
  margin-bottom: 1.5rem;

  img {
    width: 64px;
    height: 64px;
    object-fit: contain;
  }
`;

const Title = styled.h2`
  font-size: 1.5rem;
  color: #1f2937;
  margin-bottom: 1rem;
  font-weight: 600;
  font-family: "Inter", sans-serif;
`;

const Message = styled.p`
  color: #6b7280;
  margin-bottom: 2rem;
  line-height: 1.5;
  font-family: "Inter", sans-serif;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
`;

const Button = styled.button`
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.2s;

  ${(props) =>
    props.primary
      ? `
    background-color: #6366f1;
    color: white;
    &:hover {
      background-color: #4f46e5;
    }
  `
      : `
    background-color: #f3f4f6;
    color: #4b5563;
    &:hover {
      background-color: #e5e7eb;
    }
  `}
`;

const Modal = ({ isModalOpen, setIsModalOpen }) => {
  const handleClose = () => {
    setIsModalOpen(false);
  };

  return (
    <Overlay>
      <ModalContainer>
        <IconWrapper>
          <img src={email} alt="Email" />
        </IconWrapper>
        <Title>Thank you for getting in touch!</Title>
        <Message>
          Your message has been received, and our team will be in touch with you
          shortly.
        </Message>
        <ButtonGroup>
          <Button onClick={handleClose}>Close</Button>
        </ButtonGroup>
      </ModalContainer>
    </Overlay>
  );
};

export default Modal;
